import { Box } from '@mantine/core';
import { ConfigFieldValue } from '@/types/automationFields.ts';
import StyledCheckbox from '@/components/StyledInputFields/StyledCheckbox.tsx';
import useFieldConfigError from '@/hooks/useFieldConfigError.ts';
import { IntegrationCheckboxConfigField } from '@/types/integrations.ts';

type props = {
  stepId: string;

  field: IntegrationCheckboxConfigField;
  fieldValue: any;
  fieldValueConfig: ConfigFieldValue;
  onChange: (updated_value: any) => void;
};

const CheckboxField = ({ stepId, field, fieldValue, fieldValueConfig, onChange }: props) => {
  const error = useFieldConfigError(stepId, fieldValueConfig);

  return (
    <Box pos="relative">
      <StyledCheckbox
        label={field.display_name}
        // value={fieldValue || ''}
        checked={!!fieldValue}
        description={field.description ?? undefined}
        placeholder={field.placeholder ?? undefined}
        onChange={(event) => onChange(event.currentTarget.checked)}
        required={true}
        error={error?.message}
        disabled={fieldValueConfig.is_disabled}
        styles={{ label: { marginBottom: 0 } }}
      />
    </Box>
  );
};

export default CheckboxField;
